import { PulseIcon, ShieldIcon } from "@primer/octicons-react";
import "./ComplianceMetric.css";

const presentations = {
  gap: { Icon: ShieldIcon, label: "Compliance gap", first: "mandatory", second: "advisory" },
  impact: { Icon: PulseIcon, label: "Compliance impact", first: "violations", second: "advisories" }
};

export function ComplianceMetric({ advisory, kind, mandatory, size = "compact" }) {
  const presentation = presentations[kind];
  const label = kind === "impact"
    ? `${presentation.label}: ${mandatory} ${countLabel(mandatory, "violation")}, ${advisory} ${countLabel(advisory, "advisory", "advisories")}`
    : `${presentation.label}: ${mandatory} ${presentation.first}, ${advisory} ${presentation.second}`;
  const severity = mandatory ? "danger" : advisory ? "attention" : "success";
  const Icon = presentation.Icon;
  return <span aria-label={label} className={`${size} ${severity} ${kind} compliance-metric`} role="img">
    <span className="label"><Icon aria-hidden="true" />{kind === "gap" ? <span>Compliance gap</span> : null}</span>
    <span className="mark"><span>{mandatory}</span><span>-</span><span>{advisory}</span></span>
  </span>;
}

export function ComplianceImpact({ impact }) {
  if (!impact?.violations && !impact?.warnings) return null;
  return <ComplianceMetric advisory={impact.warnings} kind="impact" mandatory={impact.violations} />;
}

function countLabel(count, singular, plural = `${singular}s`) {
  return count === 1 ? singular : plural;
}
